import React, { Fragment, RefObject } from "react";
import { CodeScannerFormat } from "../code-scanner/code-scanner";
import { useCameraCodeDetector } from "./use-camera-code-detector";

interface ICameraScannerHookProps {
    formats: CodeScannerFormat[];
    onValueScan: ((value: string) => void);
    videoSource: RefObject<HTMLVideoElement>;
}

export const CameraCodeReader = (props: ICameraScannerHookProps) => {
    useCameraCodeDetector(props.videoSource, props.formats, props.onValueScan);

    return <Fragment />;
};
